import { render } from "./SingleEducation.vue?vue&type=template&id=303d3a58&scoped=true"
import script from "./SingleEducation.vue?vue&type=script&lang=js"
export * from "./SingleEducation.vue?vue&type=script&lang=js"

import "./SingleEducation.vue?vue&type=style&index=0&id=303d3a58&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303d3a58"]])

export default __exports__